import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../service/session/session.module';
import { LoadingService } from '../../directive/loading/loading.service';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AdminAmenitiesUpdateComponent } from './admin-amenities-update/admin-amenities-update.component';

@Component({
  selector: 'app-admin-amenities',
  templateUrl: './admin-amenities.component.html',
  styleUrls: ['./admin-amenities.component.css']
})
export class AdminAmenitiesComponent implements OnInit {

  amenitiesMin = {
    max: 10,
    page: 1,
  }
  list = [];
  paginator = {
    total:0,
    pageSizeOptions:[ 2 ,5, 10, 25, 100],
  };
  pageEvent: PageEvent;
  constructor(private session: SessionService,
    public loadding:LoadingService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.getamenitiess();
  }

  /**función para obtener el listado de categorias
  */
  getamenitiess(){
    this.session.postRequest("amenities:list",this.amenitiesMin).subscribe((data:any)=>{
      this.list = data.object.instanceList;
      this.paginator.total = data.object.total;
    },error=>{
      console.log("error:amenities:list",error);
    })
  }

  /** funcionalidad para crear una categoria
  */
  updateamenities(uuid){
    const dialogRef = this.dialog.open(AdminAmenitiesUpdateComponent, {
      width: '50%',
      height: '90%',
      data: uuid,
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined ){
        if(result.transaction == 'ok'){
          // El modal se cerro con objeto
          this.getamenitiess();
        }else{
          // El modal se cerro sin objeto
          this.snackBar.open('No se guardo ningun registro', '', {
            duration: 1000
          });
        }
      }else{
        // El modal se cerro sin seleccionar algo, dandole click fuera
        this.snackBar.open('No se guardo ningun registro', '', {
          duration: 1000
        });
      }
    });
  }

  deleteamenities(object){
    this.loadding.show(true, "Espere un momento...");
    this.session.postRequest("amenities:delete",object).subscribe((data:any)=>{
      for(let i=0; i < this.list.length; i++){
        if(this.list[i].id == object.id){
          this.list.splice(i,1);
          break;
        }
      }
      this.loadding.hide();
    },error=>{
      console.log("error:amenities:delete",error);
      this.loadding.hide();
    })
  }

  // funcion para obtener los datos del paginado.
  onPaginateChange(event){
    this.amenitiesMin.max = event.pageSize;
    this.amenitiesMin.page = event.pageIndex + 1;
    this.getamenitiess();
  }


}
